import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast, { type PluginOptions, POSITION } from 'vue-toastification'
import router from './router'
import App from './App.vue'
import './styles/main.css'
import 'vue-toastification/dist/index.css'
import { useAuthStore } from './stores/auth'

const toastOptions: PluginOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 4000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  hideProgressBar: false,
  icon: true,
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(Toast, toastOptions)

const auth = useAuthStore()
auth.initialize().finally(() => {
  app.use(router)
  app.mount('#app')
})
